import Vimeo from '@u-wave/react-vimeo'
import React, { useEffect, useState } from 'react'
import { FadeLoader } from 'react-spinners'
import Button from '../../../../components/button'
import { Link, useNavigate } from 'react-router-dom'
import TickMark from '../../../../components/tickmark'
import { creatDummyAppointment, saveStepsProgress } from '../../../../services/medium'
import { useTranslation, Trans } from 'react-i18next'

export default function StepThree({ NextStep,innerWidthHandler }) {
    const { t } = useTranslation("mediumBooking");
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(true);
    const [verificationStatus, setVerificationStatus] = useState(0);
    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);
    const [check4, setCheck4] = useState(false);
    const [error, setError] = useState(false);


    useEffect(() => {
        let check = localStorage.getItem('no-api-call');
        console.log(check);
        if (check === null) {

            creatDummyAppointmentHandler()
        }
    }, [])
    const changeHandler = (e, setCheck, type) => {

        setCheck(e.target.checked);
    };

    const onClickHandler = () => {
        if (
            check1 &&
            check3 &&
            check4
        ) {
            setError(false);
            setVerificationStatus(1);
            setShowLoader(false);
            savestep()
        } else {
            setError(true);
        }
    };
    const creatDummyAppointmentHandler = () => {
        let body = {
            service: 1,
            session_length: 62
        }
        creatDummyAppointment(body).then((data) => {
            if(data.data.status){

                localStorage.setItem('no-api-call',"no-api-call");
            }
        }).then(() => {

        })
    }
    const savestep = () => {
        let body = {
            step_number: 3
        }
        saveStepsProgress(body).then((data) => {
            if (data.data.status) {
                localStorage.setItem('step',3)
                NextStep()
            }
        }).catch(() => {

        })
    }
    return (
        <div className="onboarding-step-content">
            <div className='onboarding-step-header text-left'>

                <span className="onboarding-step-badge">{t("steps.stepNumber", { number: 3 })}</span>
                <div>
                    <h3 className='font-size-40'>{t("step3.title")}</h3>
                    <ol className='font-size-18 line-height-24px'>
                        <li><Trans i18nKey="step3.testBooking" ns="mediumBooking" components={{ p: <p className='text-underline' /> }} />  </li>
                        <li>{t("step3.checkEmail")}</li>
                        <li>{t("step3.checkBoxes")}</li>
                        <li><Trans i18nKey="step3.questions" ns="mediumBooking" components={{ a: <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank" rel="noreferrer" /> }} /></li>
                    </ol>
                </div>
                {/* <p className='font-size-18 line-height-24px'>
                    Now our system will make a test appointment booking with you. Please check your email, calendar (if connected), zoom account, and the Appointments page.
                    Then check the boxes below. If you have any questions or issues please email us at <a href='mailto:support@verysoul.com'>support@verysoul.com</a>
                </p> */}
            </div>

            <div className="onboarding-checklist-card step-three-checklist">
            <div class="question-container">
                <div class="text-left">
                    <div class="">
                        <div class="card px-0 pt-4 pb-0 mt-3">
                            <form id="">
                                <fieldset>
                                    <div class="form-card margin-unset">
                                        <div class="row wrap">
                                            <h2 className="text-left mb-3">
                                                {t("step3.confirmEachItem")}
                                            </h2>


                                            <div class="new margin-unset">
                                                <div class="form-group">
                                                    <input
                                                        onChange={(e) => {
                                                            changeHandler(e, setCheck1);
                                                        }}
                                                        checked={check1}
                                                        name="check1"
                                                        type="checkbox"
                                                        id="check1"
                                                    />
                                                    <label htmlFor="check1">{t("step3.check1")}
                                                    </label>
                                                    {/* <p className='onboarding-check-help'>(May take up to 10 minutes if you have an outlook or yahoo email address. Please double check your spam or junk folders for our emails)</p> */}
                                                    {/* <ol className='ml-5 mt-1 line-height-20px' type="i">
                                                        <li>                                         </li>
                                                    </ol> */}

                                                </div>
                                                <div class="form-group">
                                                    <input
                                                        checked={check4}
                                                        onChange={(e) => {
                                                            changeHandler(e, setCheck4);
                                                        }}
                                                        name="check4"
                                                        type="checkbox"
                                                        id="check4"
                                                    />
                                                    <label htmlFor="check4">
                                                    {t("step3.check4")}
                                                    </label>

                                                </div>
                                                <div class="form-group">
                                                    <input
                                                        onChange={(e) => {
                                                            changeHandler(e, setCheck2);
                                                        }}
                                                        checked={check2}
                                                        name="check2"
                                                        type="checkbox"
                                                        id="check2"
                                                    />
                                                    <label htmlFor="check2">
                                                        {t("step3.check2")}

                                                    </label>
                                                </div>

                                                <div class="form-group">
                                                    <input
                                                        onChange={(e) => {
                                                            changeHandler(e, setCheck3);
                                                        }}
                                                        checked={check3}
                                                        name="check3"
                                                        type="checkbox"
                                                        id="check3"
                                                    />
                                                    <label htmlFor="check3">
                                                        {t("step3.check3")}
                                                    </label>
                                                </div>
                                               


                                                {error && (
                                                    <div>
                                                        <p className="red">{t("step3.error")}</p>
                                                    </div>
                                                )}
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>



                                    <>

                                    </>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div className='onboarding-actions'>

                <Button
                    className={"action-button margin-unset"}
                    status={0}

                    onClick={() => onClickHandler()}
                    title={t("steps.next")} />

                {/* <Button
                    className={"action-button margin-unset ml-5"}
                    status={0}
                    onClick={openAppointMent}
                    title="Link your calendar" /> */}


            </div>

        </div>
    )
}
